import Icon7z from './svg/7z.svg';
import IconAac from './svg/aac.svg';
import IconAi from './svg/ai.svg';
import IconArchive from './svg/archive.svg';
import IconArj from './svg/arj.svg';
import IconAudio from './svg/audio.svg';
import IconAvi from './svg/avi.svg';
import IconCss from './svg/css.svg';
import IconCsv from './svg/csv.svg';
import IconDbf from './svg/dbf.svg';
import IconDoc from './svg/doc.svg';
import IconDwg from './svg/dwg.svg';
import IconExe from './svg/exe.svg';
import IconFla from './svg/fla.svg';
import IconFlac from './svg/flac.svg';
import IconGif from './svg/gif.svg';
import IconHtml from './svg/html.svg';
import IconIso from './svg/iso.svg';
import IconJpg from './svg/jpg.svg';
import IconJs from './svg/js.svg';
import IconJson from './svg/json.svg';
import IconMdf from './svg/mdf.svg';
import IconMp2 from './svg/mp2.svg';
import IconMp3 from './svg/mp3.svg';
import IconMp4 from './svg/mp4.svg';
import IconMxf from './svg/mxf.svg';
import IconNrg from './svg/nrg.svg';
import IconPdf from './svg/pdf.svg';
import IconPng from './svg/png.svg';
import IconPpt from './svg/ppt.svg';
import IconPsd from './svg/psd.svg';
import IconRar from './svg/rar.svg';
import IconRtf from './svg/rtf.svg';
import IconSvg from './svg/svg.svg';
import IconText from './svg/text.svg';
import IconTiff from './svg/tiff.svg';
import IconTxt from './svg/txt.svg';
import IconUnknown from './svg/unknown.svg';
import IconVideo from './svg/video.svg';
import IconWav from './svg/wav.svg';
import IconWma from './svg/wma.svg';
import IconXls from './svg/xls.svg';
import IconXml from './svg/xml.svg';
import IconZip from './svg/zip.svg';

const icons = {
    _7z: Icon7z,
    aac: IconAac,
    ai: IconAi,
    archive: IconArchive,
    arj: IconArj,
    audio: IconAudio,
    avi: IconAvi,
    css: IconCss,
    csv: IconCsv,
    dbf: IconDbf,
    doc: IconDoc,
    dwg: IconDwg,
    exe: IconExe,
    flac: IconFlac,
    fla: IconFla,
    gif: IconGif,
    html: IconHtml,
    iso: IconIso,
    jpg: IconJpg,
    json: IconJson,
    js: IconJs,
    mdf: IconMdf,
    mp2: IconMp2,
    mp3: IconMp3,
    mp4: IconMp4,
    mxf: IconMxf,
    nrg: IconNrg,
    pdf: IconPdf,
    png: IconPng,
    ppt: IconPpt,
    psd: IconPsd,
    rar: IconRar,
    rtf: IconRtf,
    svg: IconSvg,
    text: IconText,
    tiff: IconTiff,
    txt: IconTxt,
    unknown: IconUnknown,
    video: IconVideo,
    wav: IconWav,
    wma: IconWma,
    xls: IconXls,
    xml: IconXml,
    zip: IconZip,
};

export default icons;
